import Staction from '@bluebeam/staction';
import actions, { AppActions } from 'actions';
import Routes from 'components/Routes';
import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import { History } from 'history';
import { enableMapSet } from 'immer';
import { getAppServices } from 'providers/app-services';
import { createDIContainerProvider } from 'providers/DIContainerProvider';
import React from 'react';
import { AppState } from 'records/AppState';
import Toaster from 'utils/toast/Toaster';
import { environmentVars } from '../../constants/services';
import './App.css';

type Props = {
  history: History;
};

class App extends React.Component<Props> {
  store: AppStore;

  constructor(props: Props) {
    super(props);

    const initState = new AppState();

    this.store = new Staction<AppState, AppActions>();

    this.store.disableLogging();

    // window.appStore is only for temp development, and will be removed.
    // @ts-ignore
    window.appStore = this.store;

    this.store.init(
      actions,
      (): AppState => initState,
      (state: AppState): void => {
        this.setState(state);
      }
    );
    enableMapSet();
  }

  getAppStore = (): AppStore => {
    return this.store;
  };

  render(): React.ReactNode {
    return (
      <>
        {environmentVars.TEST_TOAST ? <Toaster /> : null}
        <AppStoreContext.Provider value={this.store}>
          <Routes history={this.props.history} />
        </AppStoreContext.Provider>
      </>
    );
  }
}

const AppWrapper: React.VFC<Omit<Props, 'services'>> = ({ history }) => {
  const [DIContainerProvider] = React.useState(() =>
    createDIContainerProvider(getAppServices())
  );

  return (
    <DIContainerProvider>
      <App history={history} />
    </DIContainerProvider>
  );
};

export default AppWrapper;
